// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ImAm","title":"Header_title__2nxdU","left":"Header_left__1jPyO","clinicName":"Header_clinicName__QBj_q"};